// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutDeliveryMethodStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        gap: ${fontConfig.spacing.smallHeading};
    `,
};

onePageCheckoutDeliveryMethodStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

onePageCheckoutDeliveryMethodStyles.servicesGridItem = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

onePageCheckoutDeliveryMethodStyles.noCarriersFoundGridItem = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutDeliveryMethodStyles.localDeliveryMessage = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutDeliveryMethodStyles.notesTextAreaStyle = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
            height: 80px;
        `,
    },
};
